// 프로젝트 내부 사용할 코인 명, 아이콘 세팅
export const serviceCoinList = [
  { id: 1, name: "BTC", icon: "logo_btc.svg" },
  { id: 2, name: "ETH", icon: "logo_eth.svg" },
  { id: 3, name: "XRP", icon: "logo_xrp.svg" },
  { id: 4, name: "SOL", icon: "logo_sol.svg" },
  { id: 5, name: "ADA", icon: "logo_ada.svg" },
  { id: 6, name: "DOGE", icon: "logo_doge.svg" },
  { id: 7, name: "BNB", icon: "logo_bnb.svg" },
];

// 스토어 이름
export const storeName = {
  user: "userStore",
  buy: "buyStore",
  markP: "markPriceStore",
  asset: "assetStore",
  core: "coreStore",
  tradeHistory: "tradeStore",
  stop: "stopStore",
  manual: "manualStore",
  buyConfig: "buyConfigStore",
  bs: "bottomStore",
};
